<template>
  <div class="sidebar-container">
    <div class="sidebar-logo">
      <img src="@/assets/nearcode_cut.png" height="50px" alt="" />
    </div>
    <ul class="sidebar-navigation">
      <!--<li class="header"></li>-->
      <li>
        <router-link to="/"><a href="#"> Homepage </a></router-link>
      </li>
      <li>
        <router-link to="/applications">
          <a href="#">
            <i class="fa fa-camera-retroz" aria-hidden="true"></i> Candidaturas
          </a>
        </router-link>
      </li>
      <li>
        <router-link to="/recruitment"
          ><a href="#">
            Ofertas
          </a></router-link
        >
      </li>
      <li>
        <router-link to="/website"
          ><a href="#">
            Website
          </a></router-link
        >
      </li>
      <li v-if="type == 1">
        <router-link to="/users"
          ><a href="#">
            Utilizadores
          </a></router-link
        >
      </li>
      <li>
        <router-link to="/profile">
          <a href="#">
            Perfil
          </a></router-link
        >
      </li>
      <li>
        <a href="#" v-on:click="logout()">
          Logout
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data: function() {
    return { loggedUser: "", type: "" };
  },
  created() {
    this.getUser();
  },
  updated() {
    this.getUser();
  },
  methods: {
    logout() {
      this.$store.commit("LOGOUT");
    },
    getUser() {
      this.loggedUser = this.$store.getters.getUserData;
      this.type = this.loggedUser.type;
    },
  },
  computed: {
    ...mapGetters(["getUserData"]),
  },
};
</script>
<style scoped>
/* @media (min-width: 992px) {
  .vertical-nav {
    position: fixed;
    top: 60px;
    left: 0;
    width: 20%;
    height: 100%;
    background-color: #888888;
    overflow-y: auto;
    padding-top: 30px;
    padding-left: 30px;
  }
}
#logo {
  margin-left: 30px;
  height: 50px;
  width: auto;
}
nav {
  background-color: #888888;
} */
.sidebar-container {
  position: fixed;
  width: 220px;
  height: 100%;
  left: 0;
  overflow-x: hidden;
  overflow-y: auto;
  background: #888888;
  color: #fff;
}

.content-container {
  padding-top: 20px;
}

.sidebar-logo {
  padding: 20px 30px 20px 30px;
  background-color: #292929;
}

.sidebar-navigation {
  padding: 0;
  margin: 0;
  list-style-type: none;
  position: relative;
}

.sidebar-navigation li {
  background-color: transparent;
  position: relative;
  display: inline-block;
  width: 100%;
  line-height: 50px;
}

.sidebar-navigation li a {
  padding: 10px 15px 10px 30px;
  display: block;
  color: #fff;
}

.sidebar-navigation li .fa {
  margin-right: 10px;
}

.sidebar-navigation li a:active,
.sidebar-navigation li a:hover,
.sidebar-navigation li a:focus {
  text-decoration: none;
  outline: none;
}

.sidebar-navigation li::before {
  background-color: #f7941e;
  position: absolute;
  content: "";
  height: 100%;
  left: 0;
  top: 0;
  -webkit-transition: width 0.2s ease-in;
  transition: width 0.2s ease-in;
  width: 3px;
  z-index: -1;
}

.sidebar-navigation li:hover::before {
  width: 100%;
}

.sidebar-navigation .header {
  font-size: 12px;
  text-transform: uppercase;
  background-color: #151515;
  padding: 10px 15px 10px 30px;
}

.sidebar-navigation .header::before {
  background-color: transparent;
}

.content-container {
  padding-left: 220px;
}
</style>
